import React, { Suspense as ReactSuspense } from 'react';

export default function Suspense({ children }) {
  return <ReactSuspense fallback={''}>{children}</ReactSuspense>;
}
